import { createI18n } from 'vue-i18n'
import en from './en.json'

export const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  messages: { en },
  // A missing key must be loud in development and silent in production — a raw key on
  // screen is better than a crash, but it must never ship unnoticed.
  missingWarn: import.meta.env.DEV,
  fallbackWarn: import.meta.env.DEV,
})
